import React, { useCallback, useMemo } from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HStack, T } from 'govwell-ui'

import { EmptySearchHint, SectionCount, StyledSubHeader } from './styled-components'

export const CANDIDATE_SECTION_KEY_PREFIX = 'candidate-section:'

type Props = {
  count: number
  id: string
  isExpanded: boolean
  isSearching: boolean
  label: string
  onToggle: (sectionKey: string) => void
  showEmptyHint?: boolean
}
const CandidateSectionHeader = ({
  count,
  id,
  isExpanded,
  isSearching,
  label,
  onToggle,
  showEmptyHint,
}: Props) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id })

  const handleClick = useCallback(() => {
    if (!isSearching) {
      onToggle(id)
    }
  }, [id, isSearching, onToggle])

  const wrapperStyle = useMemo<React.CSSProperties>(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
    }),
    [transform, transition]
  )

  return (
    <div ref={setNodeRef} style={wrapperStyle}>
      <StyledSubHeader
        {...attributes}
        {...listeners}
        onClick={handleClick}
        className={`pointer-events-auto ${isSearching ? 'cursor-default' : 'cursor-pointer'}`}
      >
        <HStack gap={2}>
          {!isSearching && (
            <FontAwesomeIcon
              icon={isExpanded ? faChevronDown : faChevronRight}
              className="text-xs"
            />
          )}
          <T.Body as="span">{label}</T.Body>
          <SectionCount>({count})</SectionCount>
        </HStack>
      </StyledSubHeader>
      {showEmptyHint && <EmptySearchHint>No matching columns</EmptySearchHint>}
    </div>
  )
}

export default React.memo(CandidateSectionHeader)
